import { render, staticRenderFns } from "./Setpwd.vue?vue&type=template&id=49e0a9fc&"
import script from "./Setpwd.vue?vue&type=script&lang=js&"
export * from "./Setpwd.vue?vue&type=script&lang=js&"
import style0 from "./Setpwd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports